module.exports = "/images/e_on_energilosningar_aktiebolag.png?787688546c96cbfb05ce7db967c0a3bb";